import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  
} from "reactstrap";
import { Field, reduxForm } from "redux-form";

import 'react-accessible-accordion/dist/fancy-example.css';


//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Util from "../../../Common/util";
import XLSX from "xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import styled, { css } from "styled-components";
import * as FileSaver from 'file-saver';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';



const Heading = [['ID','Sku'  ,'Sku Product Name',  'Child Sku',  'Child Product Name'  ,'Child Sku Qty']]
var url = window.location.hostname;
var port = window.location.port;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.toggle = this.toggle.bind(this);


    this.state = {
      ShowpopupLoader: false,
      showFilter: false,
      ShowConfirmLoader: false,
      stationType: [],
      unAssignOrder: [],
      assignOrder: [],
      isDisabledSearch: false,
      showConfirmError: false,
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      order: [],
      row_data: [],
      arr_data: [],
      isDisabledApply: false,
      disabledcheck: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      showTable: false,
      status_type: "1",
      apply: true,
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      selectedStation:"",
      disabledBtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      isChecked: false,
      filtered_orderData : [],
    };
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
 

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8088";
    } else {
      url = window.location.hostname+port;
    }
    
   

    var cookieUsername = Util.getCookie("token");
    var Location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
  
      },
      () => {
        this.fetchDispatch();
      }
    );
  }

  

 


  
   fetchDispatch = (order_no) => {
    this.setState({
      loading_overlay: true,
      loading: true,
    });

     const payload = {
            master_type: "sku_child_master"
          };

        API.post('/jogeshwari/details/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        this.setState({
          orderData: data.data,
          filtered_orderData : data.data,
          tableRowsMap: this.assembleDispatchData(data.data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };

  assembleDispatchData = (dispatchData) => {
    console.log("dispatchData", dispatchData)
    let DispatchData = dispatchData.map((post, index) => {
    
      return {
        sku:post.sku,
        sku_product_name: post.sku_product_name,
        child_sku: post.child_sku,
        child_product_name: post.child_product_name,
        child_sku_qty: post.child_sku_qty,
        parent_sku_qty: post.parent_sku_qty,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {
      // var value = this.state.orderData.filter(
      //   (val) =>
      //     val.sku.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.sku_product_name.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.child_sku.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.child_product_name.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.child_sku_qty.toString().includes(evt) 

      // );
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: "Sku",

          field: "sku",
          width: 120,
        },
        {
          label: "Sku Product Name",

          field: "sku_product_name",
          width: 220,
        },
        {
          label: "Child Sku",

          field: "child_sku",
          width: 150,
        },
        {
          label: "Child Product Name",

          field: "child_product_name",
          width: 220,
        },
        {
          label: "Child Sku Qty",

          field: "child_sku_qty",
          width: 120,
        },
        {
          label: "parent Sku Qty",

          field: "parent_sku_qty",
          width: 120,
        },
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>
        
         {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>

          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              <div className="table_header" style={{borderBottomWidth:'0px'}}>
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">SKU Child Product Master</h4>
              
        <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.filtered_orderData, "SKU Child Product Master", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
      <hr style={{marginTop:'30px',marginBottom:'0px'}}/>
              
             <div
                className="dispatchData stock_check_data"
              >             
                <MDBDataTable
                  scrollX
                  scrollY
                  onSearch={this.filterData}
                  maxHeight="390px"
                  sortable={false}
                  displayEntries={false}
                  striped
                  bordered
                  data={dispatchData}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'category_master_view', 'datatable_pagination_change' )}
                />
              </div>        
            </CardBody>
          )}
        </Card> 
      </Col>
    );
  }
}



export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
